exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VerDetalleSimSolicitudes .h2_title[data-v-2fd864c5] {\n  font-weight: normal;\n}\n", ""]);

// exports
